const SELECTORS = {
  container: '[data-parent-company-fields]',
  rows: '[data-parent-company-rows]',
  row: '[data-parent-company-row]',
  select: '[data-parent-company-select]',
  addButton: '[data-add-parent-company]',
  removeButton: '[data-remove-parent-company]',
  template: '[data-parent-company-template]'
}

export class ParentCompanyFieldsController {
  constructor(container) {
    this.container = container
  }

  connect() {
    if (this.container.dataset.parentCompanyFieldsInitialized === 'true') return

    this.container.dataset.parentCompanyFieldsInitialized = 'true'
    this.container.addEventListener('click', (event) => this.handleClick(event))
    this.container.addEventListener('change', (event) => {
      if (event.target.matches(SELECTORS.select)) this.refreshDisabledOptions()
    })
    this.refreshDisabledOptions()
  }

  handleClick(event) {
    const addButton = event.target.closest(SELECTORS.addButton)
    if (addButton) {
      this.addRow()
      return
    }

    const removeButton = event.target.closest(SELECTORS.removeButton)
    if (removeButton) this.removeRow(removeButton.closest(SELECTORS.row))
  }

  addRow() {
    const template = this.container.querySelector(SELECTORS.template)
    const row = template.content.firstElementChild.cloneNode(true)
    this.container.querySelector(SELECTORS.rows).appendChild(row)
    window.initializeDynamicSelect2?.(row)
    this.refreshDisabledOptions()
  }

  removeRow(row) {
    const select = row.querySelector(SELECTORS.select)
    if (window.jQuery && window.jQuery(select).data('select2')) {
      window.jQuery(select).select2('destroy')
    }
    row.remove()
    this.refreshDisabledOptions()
  }

  refreshDisabledOptions() {
    const selects = Array.from(this.container.querySelectorAll(SELECTORS.select))
    const selectedValues = selects.map((select) => select.value).filter(Boolean)

    selects.forEach((select) => {
      Array.from(select.options).forEach((option) => {
        option.disabled = Boolean(option.value) && option.value !== select.value && selectedValues.includes(option.value)
      })
    })
  }
}

export const initializeParentCompanyFields = () => {
  document.querySelectorAll(SELECTORS.container).forEach((container) => {
    new ParentCompanyFieldsController(container).connect()
  })
}

document.addEventListener('DOMContentLoaded', initializeParentCompanyFields)
document.addEventListener('turbolinks:load', initializeParentCompanyFields)
document.addEventListener('turbo:load', initializeParentCompanyFields)
